// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"ProjectDashboard_widgetContainer__2vg_-"};